import { createRoot, Root } from 'react-dom/client';
import FootageViewer from './React/FootageViewer';
import { ModalProvider } from './React/ModalContext';

/**
 * Bridge from Razor/vanilla JS into the React footage viewer.
 *
 * Host pages (e.g. Staff/Cases/Edit) call this whenever case settings change
 * (datetime, GPS, hours interval, search radius). Roots are cached per DOM node
 * so those calls update props instead of createRoot()-ing again and wiping state.
 * Camera checkbox memory still lives in FootageViewer (module Map keyed by caseId).
 */
const footageViewerRoots = new WeakMap<HTMLElement, Root>();

/**
 * @param domNode Mount target (typically #react-incident-viewer)
 * @param caseId Used to scope page-lifetime camera selection memory
 * @param radiusActive Inner "active" search radius in miles (default 0.25)
 * @param radiusMiles Outer search radius in miles (default 1)
 */
export function renderFootageViewer(domNode,
                                    dateTimeLocal,
                                    timezone,
                                    lat,
                                    lng,
                                    onChange,
                                    playbackRate=.5,
                                    radiusMiles = 1,
                                    hoursInterval = 1,
                                    caseId = undefined,
                                    radiusActive= .25) {
    let root = footageViewerRoots.get(domNode);
    if (!root) {
        root = createRoot(domNode);
        footageViewerRoots.set(domNode, root);
    }

    root.render(
        <ModalProvider>
            <FootageViewer
                datetimeLocal={dateTimeLocal}
                timezone={timezone}
                lat={lat}
                lng={lng}
                onChange={onChange}
                playbackRate={playbackRate}
                radiusMiles={radiusMiles}
                hoursInterval={hoursInterval}
                caseId={caseId}
                radiusActive={radiusActive}
            />
        </ModalProvider>
    );

    return root;
}

window.renderFootageViewer = renderFootageViewer;